module.exports = __webpack_public_path__ + "img/fuel-can-icon.82b14cde.svg";